import React from 'react';

// styles
import css from './notice.sss';

export const Notice = (props) => {
    const { image, title, children } = props;
    return (
        <div className={css.root}>
            <div className={css.content}>
                {image && (
                    <div className={css.imageHolder}>
                        <img
                            className={css.image}
                            src={image}
                        />
                    </div>
                )}
                {title && (
                    <div className={css.title}>
                        {title}
                    </div>
                )}
                {children && (
                    <div className={css.content}>
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};
